<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.associated_accts">
  <app-popup-header
    title="{{isUser ? localService.languageContent.associated_accts.header_business : localService.languageContent.associated_accts.header_user}}"></app-popup-header>
  <div class="modal-body" *ngIf="items">
    <div *ngIf="items.length == 0">
      {{localService.languageContent.associated_accts.no_records}}
    </div>
    <div *ngIf="items.length > 0">
      {{localService.languageContent.associated_accts.block_items}}
    </div>
    <div class="row styled_row" *ngFor="let item of items">
      <div class="col-11">
        <label style="font-weight: normal; margin-left: 15px;">
          <input type="checkbox" [(ngModel)]="item.isSelected" />
          <span class="normal_color" [ngClass]="localService.getLanguageCode(item.v2)">{{item.v1}}</span>
        </label>
        <app-qrcode-generator *ngIf="isShowBarCode" [value]="item.key" [categoryCode]="isUser ? 3 : 4"
          [countryCode]="localService.selected.countryCode"></app-qrcode-generator>
      </div>
      <div class="col-1" style="text-align: right;">
        <button class="button_icon button_icon_color icon_adjust" (click)="onAction(4,item.key)">
          subdirectory_arrow_right
        </button>
      </div>
    </div>
  </div>
  <div class="modal-footer" *ngIf="items && items.length > 0">
    <div class="row" style="width:100%">
      <div class="col-9" style="text-align:left;">
        <i class="material-icons menu_icon icon_adjust" style="color: orangered;" (click)="onAction(1)">circle</i>
        <i class="material-icons menu_icon icon_adjust" style="color: yellowgreen;" (click)="onAction(2)">circle</i>
        <button style="margin-left:5px;" type="button" class="btn btn-primary" (click)="onAction(3)">{{isShowBarCode ?
          localService.languageContent.associated_accts.hide_qr :
          localService.languageContent.associated_accts.show_qr}}</button>
      </div>
      <div class="col-3" style="text-align:right;">
        <button type="button" class="btn btn-primary"
          (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
      </div>
    </div>
  </div>
</div>